import { HttpProvider } from "../http/http.provider";
import { ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
import { IHttpRequestConfig } from "../http/types/http.types";
import { createFormData } from "../util/utilities";
import { IBaseResponse, ITimeCard, ITimeSheetResponse } from "./timesheet.interface";

/**
 * HTTP delegate for the employee timesheet API surface
 * (formerly TimeSheetDelegate in employeeServicelib).
 */
export class TimeSheetDelegate
{
    constructor(private http: HttpProvider) { }

    public createNewEmployeeTimeCard(newtimecard: ITimeCard): Observable<IBaseResponse>
    {
        const formdata = createFormData(newtimecard);

        return this.http.post(ServiceEndpointConstants.endpoints.INVOICE.NEWTIMESHEET, formdata).pipe(
            map((response: any) =>
            {
                return {
                    lastTimeSheetSubmitDate: newtimecard.ToDate,
                    success: response.data.success
                } as IBaseResponse;
            }),
            share());
    }

    public updateNewEmployeeTimeCard(newtimecard: ITimeCard): Observable<any>
    {
        const formdata = createFormData(newtimecard);

        return this.http.post(ServiceEndpointConstants.endpoints.INVOICE.UPDATE_TIMESHEET, formdata).pipe(
            map((response: any) =>
            {
                return response.data;
            }),
            share());
    }

    public getAllTimeSheetsByProjectId(projectCodeId: string): Observable<ITimeSheetResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                ProjectCodeId: projectCodeId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.INVOICE.GET_TIMESHEET_BY_PROJECT_ID, null, config).pipe(
            map((response: any) =>
            {
                return {
                    timeSheets: response.data.timeSheets,
                    lastTimeSheetSubmitDate: response.data.lastTimeSheetSubmitDate,
                    projectCodeId: projectCodeId,
                    success: response.data.success
                } as ITimeSheetResponse;
            }),
            share());
    }
}
